import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Skills } from './shared/skills/skills-list';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'tf-settings-page-skills',
  imports: [CommonModule, Skills, TranslateModule],
  templateUrl: './settings-skills.component.html',
  styleUrl: './settings-skills.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkillsSettings {}
